import React, { useEffect, useState } from "react";
import DataTableElement from "../../../components/elements/DataTableElement";
import { useNavigate, useParams } from "react-router-dom";
import Columns from "./Columns";
import { categoriesResource, departmentsResource, salesResource, productsResource, sellersResource } from "../../../helpers/configRoutes/backend_helper";
import ModalNewSeller from "./ModalNewSeller";
import { useDispatch } from "react-redux";
import { reset_product, update_product } from "../../../store/products/action";
import CustomSelect from "../../../components/form/CustomSelect";
import CustomSearchInput from "../../../components/form/CustomSearchInput";
import { currencyUSD } from "../../../helpers/forms/formater";
import { AlertTriangle, Save } from "lucide-react";
import { Tooltip } from "react-tooltip";

const ProductsSales = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false)
    const { id } = useParams()
    const dispatch = useDispatch()
    const [tableLoad, setTableLoad] = useState({ show: false, textLoad: 'Buscando ventas...' });
    const [filters, setFilters] = useState({
        department_id: '',
        category_id: '',
        search: ''
    });
    const [items, setItems] = useState([]);
    const [sale, setSale] = useState({});
    const [modal, setModal] = useState({ show: false })
    const [sellers, setSellers] = useState([]);
    const [categories, setCategories] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [rows, setRows] = useState([])

    useEffect(() => {
        const getItems = async () => {
            const response = await salesResource('show', { params: filters }, id);
            setItems(response.products);
            setSale(response.sale);
            if (response.sale.seller_id == null) {
                const responseSellers = await sellersResource('get', { params: { select: true } })
                setSellers(responseSellers.sellers)
            }
            const productsSnCategory = response.products
                .filter(pr => !pr.product?.category_id)
                .map(pr => pr.product);

            setRows(productsSnCategory);

        };
        getItems();
    }, [filters]);

    useEffect(() => {
        const getCatalogs = async () => {
            const responseCategories = await categoriesResource('get', { params: { select: true } });
            setCategories(responseCategories.categories);
            const responseDepartments = await departmentsResource('get', { params: { select: true } });
            setDepartments(responseDepartments.departments);
        };
        getCatalogs();
    }, []);

    const addUpd = async (product = false) => {
        if (product.id) {
            dispatch(update_product(product))
        } else {
            dispatch(reset_product())
        }
        setModal({ ...modal, show: true })
    }

    const handleSave = async () => {
        const response = await salesResource('put', sale, sale.id)
        if (response.status) {
            setSale(response.sale)
        }
    }

    const cols = Columns(addUpd, filters, setFilters, categories, rows, setRows,setItems,items);

    const handleUpload = async() => {
        const response = await productsResource('put',{products:rows,multiple:true},sale.id);
        if(response.status){
            setFilters({...filters})
        }
    }

    const allRowsHaveCategory = rows.length > 0 && rows.every(r => !!r.category_id);
    const someMissingCategory = rows.length > 0 && rows.some(r => !r.category_id);
    return (
        <div className="flex flex-col w-full p-4 space-y-4">
            {/* Encabezado y botones arriba a la derecha */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div>
                    <h1 className="text-fr-dark text-2xl font-bold">#{sale.invoice?.folio} Detalle de venta</h1>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-white border border-fr-muted rounded-lg shadow">
                <div className="flex flex-col gap-1">
                    <div className="flex items-center justify-between">
                        <p className="text-sm font-medium text-fr-muted">Vendedor</p>

                        {/* Indicador de error o guardar */}
                        {sale.error?.seller && (
                            sale.seller_id == null ? (
                                <div className="flex items-center text-red-600 gap-1" data-tooltip-id={`error-${sale.id}`}>
                                    <AlertTriangle size={18} />
                                    <Tooltip id={`error-${sale.id}`} place="top">
                                        {sale.error.seller}. Selecciona un vendedor
                                    </Tooltip>
                                </div>
                            ) : (
                                <button
                                    className="flex items-center gap-1 text-green-600 hover:text-green-700 transition"
                                    onClick={() => handleSave(sale)}
                                    data-tooltip-id={`save-${sale.id}`}
                                >
                                    <Save size={18} />
                                    <span className="text-sm hidden md:inline">Guardar</span>
                                    <Tooltip id={`save-${sale.id}`} place="top">
                                        Guardar vendedor
                                    </Tooltip>
                                </button>
                            )
                        )}
                    </div>

                    <div className="font-semibold text-fr-dark">
                        {sale.error?.seller ? (
                            <div className="min-w-[160px]">
                                <CustomSelect

                                    className="text-sm"
                                    holder="Selecciona vendedor"
                                    options={sellers}
                                    value={sale.seller_id}
                                    handleChange={(e) => setSale({ ...sale, seller_id: e.target.value })}
                                />
                            </div>
                        ) : (
                            <div className="text-sm">
                                {sale.seller?.short_name} {sale.seller?.information?.name} {sale.seller?.information?.last_names}
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    <p className="text-fr-muted text-sm">Cliente</p>
                    <p className="font-semibold text-fr-dark">{sale.client_name}</p>
                </div>
                <div>
                    <p className="text-fr-muted text-sm">Fecha de venta</p>
                    <p className="font-semibold text-fr-dark">{sale.date}</p>
                </div>
                <div>
                    <p className="text-fr-muted text-sm">Condifiones de pago</p>
                    <p className="font-semibold text-fr-dark">{sale.payment_terms}</p>
                </div>

                <div>
                    <p className="text-fr-muted text-sm">Subtotal</p>
                    <p className="font-semibold text-fr-dark">{currencyUSD(sale.subtotal)}</p>
                </div>
                <div>
                    <p className="text-fr-muted text-sm">Impuestos</p>
                    <p className="font-semibold text-fr-dark">{currencyUSD(sale.invoice?.tax_total || 0)}</p>
                </div>
                <div >
                    <p className="text-fr-muted text-sm">Total</p>
                    <p className="text-xl font-bold text-fr-primary">{currencyUSD(sale.total)}</p>
                </div>
            </div>
            <div className="bg-fr-light border border-fr-muted rounded-lg shadow-md p-4">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                    <div className="flex flex-wrap items-center gap-4 w-full lg:w-auto">
                        <p className="text-fr-dark font-medium">Filtrar por:</p>
                        <div className="min-w-[160px]">
                            <CustomSelect
                                className="text-sm"
                                holder="Area"
                                options={categories}
                                value={filters.category_id}
                                handleChange={(e) => setFilters({ ...filters, category_id: e.target.value })}
                            />
                        </div>
                        <div className="min-w-[160px]">
                            <CustomSelect
                                className="text-sm"
                                holder="Departamento"
                                options={departments}
                                value={filters.department_id}
                                handleChange={(e) => setFilters({ ...filters, department_id: e.target.value })}
                            />
                        </div>
                    </div>

                    <div className="flex items-center w-full lg:w-[300px]">
                        <CustomSearchInput
                            value={filters.search}
                            handleChange={(e) => setFilters({ ...filters, search: e.target.value })}
                            placeholder="Buscar..."
                        />
                    </div>
                </div>
            </div>
            {/* Tabla */}
            <DataTableElement columns={cols} tableLoad={tableLoad} items={items} />
            {modal.show &&
                <ModalNewSeller filters={filters} setFilters={setFilters} modal={modal} setModal={setModal} />
            }


            {rows.length > 0 && (
                <button
                    onClick={handleUpload}
                    disabled={!allRowsHaveCategory || loader}
                    className={`fixed bottom-6 right-6 z-50 rounded-full w-16 h-16 flex items-center justify-center shadow-xl transition transform hover:scale-105
        ${allRowsHaveCategory
                            ? 'bg-fr-primary text-white hover:bg-fr-primary-hover'
                            : 'bg-red-500 text-white opacity-70 cursor-not-allowed'
                        }`}
                    title={
                        allRowsHaveCategory
                            ? "Guardar venta"
                            : "Debes asignar un área a todos los productos"
                    }
                >
                    {loader ? (
                        <span className="animate-spin material-symbols-outlined text-[24px]">sync</span>
                    ) : (
                        <span className="material-symbols-outlined text-[28px]">save</span>
                    )}
                </button>
            )}
        </div>
    );
};

export default ProductsSales;
